import styled from 'styled-components'
import { colors, TYPOGRAPHY, parseRem } from 'styles'

interface Props {
  lorem?: string
}

export const Pagination = styled.div<Props>`
  display: grid;
  gap: ${parseRem(16)};
  place-items: center;
  height: max-content;
  padding: ${parseRem(8)} ${parseRem(24)};
  border: 1px solid ${colors.border.default};
  border-radius: ${parseRem(8)};

  @media screen and (min-width: 960px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: initial;

    > * {
      &:not(:last-of-type) {
        margin-right: ${parseRem(16)};
      }
    }
  }
`

export const Left = styled.div<Props>`
  display: flex;
  align-items: center;
  gap: ${parseRem(40)};
  color: ${colors.content.subdued};
  font-size: ${TYPOGRAPHY.size.xxs};
`

export const SelectsWrapper = styled.div<Props>`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: ${colors.content.subdued};
  font-size: ${TYPOGRAPHY.size.xxs};

  > div {
    width: ${parseRem(90)};
    margin-left: ${parseRem(8)};
  }
`
